import React, { FunctionComponent } from 'react'
import { HeartRateIcon } from '../../Icons/Icons'

interface Props {
  name: string
}

export const MfNgRemoteMonitoringDisabledTab: FunctionComponent<Props> = ({ name }) => {
  return (
    <div className='tab'>
      <div className='content'>
        <div className='empty'>
          <i className='icon thirtytwo'>
            <HeartRateIcon />
          </i>
          <h5>{name} has disabled remote monitoring.</h5>
          <p>
            In order to view system health and feature usage, enable remote monitoring in the PaperCut Multiverse
            Connector.
          </p>
        </div>
      </div>
    </div>
  )
}
